import React from 'react';

type BrokenLinkIconProps = {
  width?: number;
  height?: number;
};

export function BrokenLinkIcon({ width = 40, height = 40 }: BrokenLinkIconProps): JSX.Element {
  return (
    <svg
      aria-label='Re-link unsuccessful'
      role='img'
      width={width}
      height={height}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_8718_16415)'>
        <path
          d='M36.75 20C36.75 10.7492 29.2508 3.25 20 3.25C10.7492 3.25 3.25 10.7492 3.25 20C3.25 29.2508 10.7492 36.75 20 36.75C29.2508 36.75 36.75 29.2508 36.75 20ZM39.25 20C39.25 30.6315 30.6315 39.25 20 39.25C9.36852 39.25 0.75 30.6315 0.75 20C0.75 9.36852 9.36852 0.75 20 0.75C30.6315 0.75 39.25 9.36852 39.25 20Z'
          fill='#464F53'
        />
        <path
          d='M12.543 8.54199C12.9335 8.15147 13.5665 8.15147 13.957 8.54199L16.957 11.542C17.3476 11.9325 17.3476 12.5655 16.957 12.9561C16.5665 13.3466 15.9335 13.3466 15.543 12.9561L12.543 9.95605C12.1524 9.56553 12.1524 8.93252 12.543 8.54199Z'
          fill='#464F53'
        />
        <path
          d='M14.75 14.249C15.3023 14.249 15.75 14.6967 15.75 15.249C15.75 15.8013 15.3023 16.249 14.75 16.249H13.25C12.6977 16.249 12.25 15.8013 12.25 15.249C12.25 14.6967 12.6977 14.249 13.25 14.249H14.75Z'
          fill='#464F53'
        />
        <path
          d='M18.25 10.749V9.24902C18.25 8.69674 18.6977 8.24902 19.25 8.24902C19.8023 8.24902 20.25 8.69674 20.25 9.24902V10.749C20.25 11.3013 19.8023 11.749 19.25 11.749C18.6977 11.749 18.25 11.3013 18.25 10.749Z'
          fill='#464F53'
        />
        <path
          d='M30.25 18.249C30.25 17.3208 29.881 16.4308 29.2246 15.7744C28.5682 15.118 27.6783 14.749 26.75 14.749H22.25C21.6977 14.749 21.25 14.3013 21.25 13.749C21.25 13.1967 21.6977 12.749 22.25 12.749H26.75C28.2087 12.749 29.6072 13.3289 30.6387 14.3604C31.6701 15.3918 32.25 16.7903 32.25 18.249C32.25 19.7077 31.6701 21.1062 30.6387 22.1377C29.6072 23.1691 28.2087 23.749 26.75 23.749H22.25C21.6977 23.749 21.25 23.3013 21.25 22.749C21.25 22.1967 21.6977 21.749 22.25 21.749H26.75C27.6783 21.749 28.5682 21.38 29.2246 20.7236C29.881 20.0673 30.25 19.1773 30.25 18.249Z'
          fill='#464F53'
        />
        <path
          d='M18.377 24.0723C18.7675 23.6817 19.4005 23.6817 19.791 24.0723C20.1814 24.4628 20.1815 25.0958 19.791 25.4863L17.1387 28.1377C16.1072 29.1691 14.7087 29.749 13.25 29.749C11.7913 29.749 10.3928 29.1691 9.36133 28.1377C8.32989 27.1062 7.75 25.7077 7.75 24.249C7.75 22.7903 8.32988 21.3918 9.36133 20.3604L12.0127 17.708C12.4032 17.3175 13.0362 17.3176 13.4268 17.708C13.8173 18.0985 13.8173 18.7315 13.4268 19.1221L10.7754 21.7744C10.119 22.4308 9.75 23.3208 9.75 24.249C9.75 25.1773 10.119 26.0673 10.7754 26.7236C11.4318 27.38 12.3217 27.749 13.25 27.749C14.1783 27.749 15.0682 27.38 15.7246 26.7236L18.377 24.0723Z'
          fill='#464F53'
        />
      </g>
      <defs>
        <clipPath id='clip0_8718_16415'>
          <rect width='40' height='40' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
